import GaugeChart from "react-gauge-chart";

const WITHIN_COLOR = "#22C55E";
const OVER_COLOR = "#EF4444";

const GaugeCard = ({ label, value, minValue = 0, maxValue = 1, unit = "", description = "Excellent", ranges = [], threshold, higherIsBetter = false }) => {
  // Convert value to 0-1 for the gauge
  const numValue = parseFloat(value) || 0;

  // const percent = (value - min) / (max - min);


  const percent = Math.min(Math.max((numValue - minValue) / (maxValue - minValue), 0), 1);

  const numThreshold = parseFloat(threshold);
  const hasThreshold = !isNaN(numThreshold);
  const thresholdPercent = hasThreshold
    ? Math.min(Math.max((numThreshold - minValue) / (maxValue - minValue), 0), 1)
    : 0.5;

  // For a semicircle gauge, percent 0 -> needle points left (-90deg), percent 0.5 -> up (0deg),
  // percent 1 -> right (+90deg). Pivot is approximated at the bottom-center of the chart box.
  const needleRotationDeg = (percent - 0.5) * 180;
  // const thresholdRotationDeg = (thresholdPercent - 0.5) * 180;
  const needleColor = "#14B8A6";
  const needlePivotColor = "#6B7280";

  // Extract colors from ranges prop (kept as the fallback look when no threshold is supplied)
  const colors = ranges.length > 0 ? ranges.map(r => r.color) : ["#9FC7FF", "#00E3C4", "#3166D8"];
  const nrOfLevels = colors.length;

  // When a threshold is supplied, show a 2-tone red/green arc split at that threshold instead
  // of the multi-tone ranges look, matching BankerUI's Key Metrics gauge colors. Arc order is
  // left-to-right: for a "lower is better" metric the safe (green) zone sits on the left, for a
  // "higher is better" metric it sits on the right.
  // const colors = hasThreshold
  //   ? (higherIsBetter ? [OVER_COLOR, WITHIN_COLOR] : [WITHIN_COLOR, OVER_COLOR])
  //   : (ranges.length > 0 ? ranges.map(r => r.color) : ["#9FC7FF", "#00E3C4", "#3166D8"]);
  // const arcsLength = hasThreshold ? [thresholdPercent, 1 - thresholdPercent] : undefined;
  // const nrOfLevels = colors.length;

  return (
    <div
      className="iconFont card-section"
      style={{
        padding: 24,
        // width: 228,
        width: "100%",
        margin: 16,
        display: "inline-block",
        verticalAlign: "top",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ color: "#F4F4F5" }}>{label}</span>
      </div>
      <GaugeChart
        id={`gauge-chart-${label}`}
        nrOfLevels={3}
        colors={["#9FC7FF", "#00E3C4", "#3166D8"]}
        nrOfLevels={nrOfLevels}
        colors={colors}
        arcWidth={0.15}
        percent={percent}
        arcPadding={0.06}
        textColor="#11305C"
        needleColor="#00E3C4"
        hideText={true}
      />
      {/* <GaugeChart
        id={`gauge-chart-${label}`}
        style={{ position: "relative" }}
        nrOfLevels={colors.length}
        arcsLength={arcsLength}
        colors={colors}
        arcWidth={0.18}
        cornerRadius={0}
        percent={percent}
        arcPadding={0}
        textColor="#11305C"
        hideText={true}
        customNeedleStyle={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: "none",
        }}
        customNeedleComponent={
          <div style={{ position: "relative", width: "100%", height: "100%" }}>
            <div
              style={{
                position: "absolute",
                left: "50%",
                bottom: "15%",
                width: 3,
                height: "58%",
                background: needleColor,
                borderRadius: 2,
                transformOrigin: "bottom center",
                transform: `translateX(-50%) rotate(${needleRotationDeg}deg)`,
              }}
            />
            <div
              style={{
                position: "absolute",
                left: "50%",
                bottom: "15%",
                width: 14,
                height: 14,
                borderRadius: "50%",
                background: needlePivotColor,
                transform: "translate(-50%, 50%)",
              }}
            />
          </div>
        }
      /> */}
      <div
        style={{
          // position: "relative",
          // top: "-15px",
          textAlign: "center",
          fontSize: "1em",
          fontWeight: "bold",
          color: "white",
        }}
      >
        {value}
        {unit}

      </div>
      <div
        style={{
          // position: "relative",
          // top: "-10px",
          textAlign: "center",
          // color: "rgb(74, 222, 128)",
          color: "#ffffff",
          fontWeight: "bold",
        }}
      >
        {description}
      </div>
    </div>
  );
};

export default GaugeCard;